// src/utils/userActivity.js
//
// Lightweight last-login / last-activity tracking, stored on the user doc so the
// superuser Users page can show it across every user (Firebase Auth's built-in
// metadata.lastSignInTime is only readable for the *current* user client-side).
//
//   users/{uid}.lastLoginAt   — the real Firebase sign-in time (accurate, only
//                               changes on an actual sign-in, not a page reload)
//   users/{uid}.lastActiveAt  — bumped while the app is open, throttled per tab

import { doc, setDoc } from "firebase/firestore";
import { firestore } from "../firebase";

const ACTIVE_THROTTLE_MS = 5 * 60 * 1000; // at most one activity write / 5 min / tab

// Record a sign-in. Uses Firebase's own lastSignInTime so a page reload (which
// also fires onAuthStateChanged) doesn't masquerade as a fresh login.
export async function recordLogin(user) {
  if (!user?.uid) return;
  const now = new Date().toISOString();
  try {
    await setDoc(
      doc(firestore, "users", user.uid),
      {
        lastLoginAt: user.metadata?.lastSignInTime || now,
        accountCreatedAt: user.metadata?.creationTime || null,
        lastActiveAt: now,
      },
      { merge: true }
    );
  } catch (e) {
    console.error("recordLogin failed", e);
  }
}

// Bump last activity, throttled so an open tab writes at most once per window.
export async function touchActivity(uid) {
  if (!uid) return;
  const key = `lastActivePing_${uid}`;
  const last = Number(localStorage.getItem(key) || 0);
  if (Date.now() - last < ACTIVE_THROTTLE_MS) return;
  localStorage.setItem(key, String(Date.now()));
  try {
    await setDoc(
      doc(firestore, "users", uid),
      { lastActiveAt: new Date().toISOString() },
      { merge: true }
    );
  } catch (e) {
    console.error("touchActivity failed", e);
  }
}
